/* The agent switcher in the Agents panel header (chat makeover #2718) */
.switcher {
  display: flex;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
}

.current {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  flex-direction: column;
}

.name {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
  font-size: var(--tuna-typography-subtitle2-fontSize);
  font-weight: var(--tuna-typography-subtitle2-fontWeight);
  color: var(--tuna-palette-text-primary);
}

.purpose,
.count {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}

.trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-borderRadius);
  background: none;
  color: var(--tuna-palette-text-secondary);
  cursor: pointer;
}

.trigger:hover {
  background: var(--tuna-palette-action-hover);
}

.trigger:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.trigger .dot {
  position: absolute;
  top: 2px;
  right: 2px;
}

/* The agent's accent marks its avatar; the dot is the product's primary colour */
.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: var(--tuna-shape-radius-circle);
  background: var(--tuna-palette-primary-main);
}

@media (pointer: coarse) {
  .trigger {
    min-width: 44px;
    min-height: 44px;
  }
}
